import { MyLogo, MyStep, MyStepper } from '@interstellar-component'
import { Mail01 } from '@untitled-ui/icons-react'
import { useState } from 'react'

import { useRegister } from './Context'
import AlertModal from './modal'
import RegisterForm from './RegisterForm'

function Register() {
  const { currentModal, handleCurrentModal } = useRegister()
  /**
   * Resume the signup wizard, but only at a step that can still be completed.
   *
   * `register_active_step` survives a reload; the account form does not. Steps
   * 3-4 only need the user id, which is also persisted, so they remain
   * reachable. Step 2 posts name/email/password, so without them there is
   * nothing to submit — resuming there used to leave the user on a screen whose
   * button silently did nothing, with clearing localStorage as the only escape.
   *
   * Computed in the state initializer on purpose: RegisterForm has an effect
   * that writes activeStep back to localStorage, and it runs before any restore
   * effect could read it.
   */
  const [activeStep, setActiveStep] = useState(() => {
    const saved = parseInt(localStorage.getItem('register_active_step') || '1', 10)
    if (!Number.isFinite(saved) || saved <= 1) return 1
    const hasUserId = !!localStorage.getItem('RrwF57&aRMoR5Eq23#Mi')
    if (saved >= 3 && hasUserId) return saved
    return 1
  })

  return (
    <>
      <AlertModal
        open={currentModal?.current === 'alert-modal'}
        handleCurrentModal={handleCurrentModal}
        currentModal={currentModal}
      />
      <main className="flex h-screen overflow-hidden z-50">
        <div className="w-[440px] bg-brand/800 max-md:hidden h-screen flex flex-col justify-between shrink-0">
          <div className="p-8 flex flex-col gap-20">
            <MyLogo showText darkMode />
            <div className="flex flex-col gap-8 pr-8">
              <MyStepper activeStep={activeStep}>
                <MyStep value={1}>
                  <div className="flex flex-col">
                    <p className="text-md-semibold text-white">Create admin account</p>
                    <p className="text-sm-regular text-white">
                      Enter your details to create the administrator account.
                    </p>
                  </div>
                </MyStep>
                <MyStep value={2}>
                  <div className="flex flex-col">
                    <p className="text-md-semibold text-white">Review terms & conditions</p>
                    <p className="text-sm-regular text-white">
                      Read and agree to the terms required to use the platform.
                    </p>
                  </div>
                </MyStep>
                <MyStep value={3}>
                  <div className="flex flex-col">
                    <p className="text-md-semibold text-white">Verify your account</p>
                    <p className="text-sm-regular text-[#B9C9EF]">
                      Enter the OTP sent to your email to confirm your account.
                    </p>
                  </div>
                </MyStep>
              </MyStepper>
            </div>
          </div>
          <div className="p-8 flex justify-between items-end h-[96px]">
            <p className="text-sm-regular text-white">© Everest 2026</p>
            <div className="flex items-center gap-2 text-white">
              <Mail01 size={17} />
              <p className="text-sm-regular">help@everest.co.id</p>
            </div>
          </div>
        </div>
        <RegisterForm activeStep={activeStep} setActiveStep={setActiveStep} />
      </main>
    </>
  )
}

export default Register
